import React from 'react';
import {
  CarOutlined,
  DollarOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  InfoCircleOutlined,
  ThunderboltOutlined,
  WarningOutlined
} from '@ant-design/icons';
import { Notification } from '../../types';
import {
  getCategoryIconColor,
  getSemanticCategory,
  getSemanticTier
} from '../../utils/notificationPresentation';

type Props = {
  notification: Notification;
};

const NotificationSemanticIcon: React.FC<Props> = ({ notification }) => {
  const category = getSemanticCategory(notification);
  const tier = getSemanticTier(notification);
  const style = { fontSize: 18, color: getCategoryIconColor(category, tier) };

  if (tier === 'CRITICAL') return <ExclamationCircleOutlined style={style} />;
  if (tier === 'WARNING' || tier === 'ACTION_REQUIRED') return <WarningOutlined style={style} />;
  if (category === 'PAYMENT' || category === 'FINANCE') return <DollarOutlined style={style} />;
  if (category === 'ROUTE') return <CarOutlined style={style} />;
  if (category === 'DOCUMENT') return <FileTextOutlined style={style} />;
  if (category === 'TASK') return <ThunderboltOutlined style={style} />;
  return <InfoCircleOutlined style={style} />;
};

export default NotificationSemanticIcon;
